import React, { useRef, useEffect, useState } from "react";

import {
    PiArrowDownLight,
    PiGlobeLight,
    PiBrainLight,
    PiUsersLight,
    PiFireLight,
    PiHandshakeDuotone,
    PiLightbulbDuotone,
    PiMegaphoneSimpleDuotone,
    PiSketchLogoDuotone,
    PiBrainDuotone,
    PiPentagramDuotone,
    PiTimerDuotone,
    PiShieldChevronDuotone,
    PiArrowCircleUpRightDuotone
} from "react-icons/pi";

import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/all";
import { useStateContext } from "../../context/ContextProvider";
import useFadeInOnScroll from "../../components/Effects/FadeInOnScroll";
import bgO from "../../assets/images/bg/bgO.png";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

function CoreValues() {
    gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

    const { isMobile, deviceSize, MARKER } = useStateContext();
    const marker = MARKER;
    //   const marker = false;

    useFadeInOnScroll();

    const corevalues = [
        {
            icon: <PiBrainDuotone size={40} color={"var(--secondary)"} />,
            title: "Innovation",
            brief: "We embrace the newest tools and technologies to stay ahead of trends and deliver groundbreaking solutions."
        },
        {
            icon: <PiPentagramDuotone size={40} color={"var(--secondary)"} />,
            title: "Excellence",
            brief: "Quality is our priority. Every project we take on is completed with precision and care."
        },
        {
            icon: <PiLightbulbDuotone size={40} color={"var(--secondary)"} />,
            title: "Creativity",
            brief: "Our unique blend of marketing minds and artistic talent allows us to craft inspiring, out-of-the-box campaigns."
        },
        {
            icon: <PiTimerDuotone size={40} color={"var(--secondary)"} />,
            title: "Timeliness",
            brief: "We value your time and ensure projects are delivered promptly without compromising quality."
        },
        {
            icon: <PiHandshakeDuotone size={40} color={"var(--secondary)"} />,
            title: "Collaboration",
            brief: "We build strong partnerships with our clients, working closely to achieve their goals."
        },
        {
            icon: <PiShieldChevronDuotone size={40} color={"var(--secondary)"} />,
            title: "Integrity",
            brief: "Transparency and trust are at the core of everything we do."
        },
    ];

    useEffect(() => {
        console.log("Current Device Size:", deviceSize);
        console.log("Is Mobile:", isMobile);
    }, [deviceSize, isMobile]);

    return (
        <>
            {/* ABOUT CONTENT */}
            <div className="my-5 py-5 w-[100vw] min-h-screen">
                <div
                    className="fade-element !bg-white rounded-t-full pb-5 w-[100vw] h-[50vh] lg:h-screen relative font-light"
                    style={{
                        background: `white url(${bgO}) center/cover no-repeat`,
                    }}
                >
                    <div className="absolute left-[7%] top-[70%] md:top-[55%] uppercase font-bold">
                        <div className="fade-element subhero-text text-[var(--primary)]">
                            CORE
                            <br />
                            VALUES
                        </div>
                    </div>
                </div>
                <div className="relative bg-white font-light padding-container py-5">
                    <div className="core-container">
                        {corevalues.map((core, index) => (
                            <div className="core-point text-[var(--secondary)]">
                                {core.icon}
                                <div className="fade-element popup w-[200px] lg:w-[300px]">
                                    <div className="text-xl md:text-2xl lg:text-4xl font-bold">
                                        0{index + 1}
                                    </div>
                                    <div className="text-xl md:text-2xl lg:text-4xl font-bold uppercase text-[var(--primary)]">
                                        {core.title}
                                    </div>
                                    <div className="text-xs md:text-sm lg:text-base">
                                        {core.brief}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
}

export default CoreValues;
